(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3MemberBenefits', {
            templateUrl: 'app/home/member-benefits/member-benefits.component.html',
            controller: MemberBenefitsComponent
        });

    MemberBenefitsComponent.$inject = ['$locale', 'user', 'cultureName', 'memberBenefitsTemplateUrl', 'clubMembershipLevelType'];
    function MemberBenefitsComponent($locale, user, cultureName, memberBenefitsTemplateUrl, clubMembershipLevelType) {
        var ctrl = this;
        Object.defineProperty(this, 'isGold', { get: getIsGold });
        Object.defineProperty(this, 'isBronze', { get: getIsBronze });
        ctrl.templateUrl = templateUrl;

        function templateUrl() {
            return memberBenefitsTemplateUrl.format(fallback($locale.id));
        }
        function getIsGold() {
            return user.membershipLevel === clubMembershipLevelType.Gold;
        }
        function getIsBronze() {
            return user.membershipLevel === clubMembershipLevelType.Bronze;
        }
        function fallback(localeId) {
            return localeId === cultureName.fr.toLowerCase() || localeId === cultureName.fr_CA.toLowerCase() ? cultureName.fr_CA : cultureName.en_CA;
        }
    }
})();